import { GetTimeSetQueryParamsType } from '@/common/queries/getTimeSet/getTimeSetQuery.type';
import { getTimeSetFunction } from '@/common/queries/getTimeSet/getTimeSetQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getTimeSetQueryOptions = (params: GetTimeSetQueryParamsType) => {
  return queryOptions({
    queryKey: ['GetTimeSetQueryParamsType', params?.id],
    queryFn: () => getTimeSetFunction(params),
  });
};
